























































import type { PropType, Ref } from '@vue/composition-api';
import { toRefs, onMounted, defineComponent, ref } from '@vue/composition-api';
import { ParagraphSize, AvatarSize } from '@getaccept/lib-ui';
import type { ChatParticipant, Message, ReadBy } from '../types';
import { MessageType } from '../types';
import { ChatHelper } from '../helpers';
import { useChatMessage } from '../composition/chat-message-composition-api';

export default defineComponent({
  name: 'ChatMessageOther',
  props: {
    message: {
      type: Object as PropType<Message>,
      default: undefined,
    },
    name: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    showName: {
      type: Boolean,
      default: false,
    },
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    fullTimestamp: {
      type: String,
      default: '',
    },
    owner: {
      type: Object as PropType<ChatParticipant>,
      default: undefined,
    },
  },
  emits: ['read'],
  setup(props, { emit }) {
    const { message, owner } = toRefs(props);
    const isTimestampVisible: Ref<boolean> = ref(false);
    const actionsVisible: Ref<boolean> = ref(false);

    const hideTimestamp = (): void => {
      isTimestampVisible.value = false;
    };

    const showTimestamp = (): void => {
      isTimestampVisible.value = true;
    };

    const hideActions = (): void => {
      actionsVisible.value = false;
    };

    const showActions = (): void => {
      actionsVisible.value = true;
    };

    onMounted(() => {
      const hasRead = message.value.reads.find(({ participant }: ReadBy) => {
        return ChatHelper.isSameParticipant(owner.value, participant);
      });
      if (!hasRead) {
        emit('read', message.value.id);
      }
    });

    const isPrivate = message.value.type === MessageType.Internal;

    const { text, textSize } = useChatMessage(message);

    return {
      isTimestampVisible,
      isPrivate,
      hideTimestamp,
      showTimestamp,
      showActions,
      hideActions,
      actionsVisible,
      ParagraphSize,
      AvatarSize,
      text,
      textSize,
    };
  },
});
